export function swapMap(map={}){const output={};for(const key in map){output[map[key]]=key}return output}export default swapMap;